const instances = new Map();

let nextPage = (slider) => (event) => {
	// const breakpoint = slider.getBreakpoint(slider.params.breakpoints);
	// const step = slider.params.breakpoints[breakpoint]?.slidesPerView;

	// slider.slideTo(slider.activeIndex + step);
	slider.slideTo(slider.activeIndex + 1);
}

let prevPage = (slider) => (event) => {
	// const breakpoint = slider.getBreakpoint(slider.params.breakpoints);
	// const step = slider.params.breakpoints[breakpoint]?.slidesPerView;

	// slider.slideTo(slider.activeIndex - step);
	slider.slideTo(slider.activeIndex - 1);
}

let paginationHandler = (prevEl, nextEl) => (slider) => {
	let { isBeginning, isEnd } = slider;

	if (isBeginning)
		prevEl.disabled = true;
	else
		prevEl.disabled = false;

	if (isEnd)
		nextEl.disabled = true;
	else
		nextEl.disabled = false;
}

// initialisation swiper

async function initSwiper(carousel, thumbs) {

	const { default: Swiper } = await import('swiper/bundle');
	// const { default: Hammer } = await import('hammerjs');

	let myThumbsSlider = thumbs.querySelector('.swiper');

	if (instances.has(myThumbsSlider))
		return;

	let nextThumb = thumbs.querySelector('.swiper-button-next-custom');
	let prevThumb = thumbs.querySelector('.swiper-button-prev-custom');

	// hidding empty slides

	// const swiperSlide = rootElement.querySelectorAll('.swiper-slide');

	// function hideElemIfEmpty(elm) {
	//   if (elm.children.length === 0) {
	//     elm.parentNode.removeChild(elm);
	//   }
	// }

	// swiperSlide.forEach(hideElemIfEmpty);

	let thumbsSwiper = new Swiper(myThumbsSlider, {
		speed: 350,
		freeMode: true,
		freeModeSticky: true,
		breakpoints: {
			0: {
				slidesPerView: 4,
			},
			850: {
				slidesPerView: 5,
			},
		},
		init: false,
	});

	instances.set(myThumbsSlider, thumbsSwiper);

	// if (instances.has(carouselSwiper))
	// 	return;


	let carouselSwiper = new Swiper(carousel, {
		speed: 350,
		slidesPerView: 1,
		init: false,
	});

	instances.set(carousel, carouselSwiper);

	let customNextPageHandler = nextPage(thumbsSwiper);
	let customPrevPageHandler = prevPage(thumbsSwiper);
	let customPaginationHandler = paginationHandler(prevThumb, nextThumb);

	let slideCarouselTo = ({ clickedIndex }) => {
		if (clickedIndex >= 0)
			carouselSwiper.slideTo(clickedIndex);
	};

	let updateThumbs = ({ activeIndex }) => {
		thumbsSwiper.slides.removeClass('pagination-container-thumbs-active');
		thumbsSwiper.slides.eq(activeIndex).addClass('pagination-container-thumbs-active');
		thumbsSwiper.slideTo(activeIndex);
	};

	thumbsSwiper.on('init', () => {
		customPaginationHandler;
		thumbsSwiper.on('click', slideCarouselTo);
		carouselSwiper.on('slideChange', updateThumbs);
	});

	thumbsSwiper.on('activeIndexChange', customPaginationHandler);
	thumbsSwiper.on('init', () => {
		nextThumb.addEventListener('click', customNextPageHandler);
		prevThumb.addEventListener('click', customPrevPageHandler);
	});
	thumbsSwiper.on('beforeDestroy', () => {
		nextThumb.removeEventListener('click', customNextPageHandler);
		prevThumb.removeEventListener('click', customPrevPageHandler);
		instances.delete(thumbsSwiper);
	});

	carouselSwiper.on('beforeDestroy', () => {
		instances.delete(carouselSwiper);
	})

	thumbsSwiper.init();
	carouselSwiper.init();

	return thumbsSwiper;
}

const root = document.querySelector('.card-home');

const pageHelp = document.querySelector('.card-help');

document.addEventListener('DOMContentLoaded', () => {
	if (root || pageHelp) {
		let prefixes = [
			'card-home',
			'report',
		]
		prefixes.forEach(prefix => {
			let carouselContainer = document.querySelector(`.${prefix}-carousel`);
			let paginationContainer = document.querySelector(`.${prefix}-pagination-container`);
			initSwiper(carouselContainer, paginationContainer)
		});
	}
});
